import React from 'react';
import { VendorDetailsRequestIntroHeader } from './components/VendorDetailsRequestIntroHeader';
import { VendorDetailsRequestIntroFooter } from './components/VendorDetailsRequestIntroFooter';
import { VendorDetailsRequestIntroContent } from './components/VendorDetailsRequestIntroContent';
import { useStore } from '../../../../store';

interface IVendorDetailsRequestIntroProps {
  businessName: string | null;
  billNumber: string | null;
  isLoading: boolean;
  onReceivePaymentClick: () => void;
  errorMessage?: string;
}

export const VendorDetailsRequestIntro = ({
  errorMessage,
  isLoading,
  businessName,
  billNumber,
  onReceivePaymentClick,
}: IVendorDetailsRequestIntroProps) => {
  const isMobileScreen = useStore((state) => state.isMobileScreen);
  const askVendorHelpCenterUrl = 'https://support.lili.co/hc/en-us/articles/8049214151706-Does-Lili-offer-a-way-to-ask-my-vendor-for-their-payment-details';
  return (
    <div
      className={`
    flex flex-col  items-center justify-between gap-0  shadow-md bg-bw01 w-full h-full overflow-hidden overscroll-y-none 
     ${isMobileScreen ? ' w-full ' : '  max-h-[610px]  max-w-[588px] rounded-md'}`}
    >
      <div className='w-full'>
        <VendorDetailsRequestIntroHeader />
        <VendorDetailsRequestIntroContent
          businessName={businessName}
          billNumber={billNumber}
          errorMessage={errorMessage}
        />
      </div>
      <div className={`w-full flex flex-col items-center  ${isMobileScreen && 'bg-bw02'}`}>
        {isMobileScreen && <div className='w-full h-[2px] bg-bw03 mb-[16px]' />}
        {!errorMessage && (
          <VendorDetailsRequestIntroFooter
            isLoading={isLoading}
            askVendorHelpCenterUrl={askVendorHelpCenterUrl}
            businessName={businessName}
            onReceivePaymentClick={onReceivePaymentClick}
          />
        )}
      </div>
    </div>
  );
};
